import { render } from "./CentroidVideoPlayer.vue?vue&type=template&id=5ee73468&scoped=true"
import script from "./CentroidVideoPlayer.vue?vue&type=script&lang=js"
export * from "./CentroidVideoPlayer.vue?vue&type=script&lang=js"

import "./CentroidVideoPlayer.vue?vue&type=style&index=0&id=5ee73468&scoped=true&lang=css"

import exportComponent from "D:\\www\\Centroid\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee73468"]])

export default __exports__